<template>
  <div>

  </div>
</template>

<script>
export default {
  name: "SystemIndexView"
}
</script>

<style scoped>

</style>